import React from 'react';
import { CoffeeIcon, ChurchIcon, MapPinIcon, CheckIcon } from 'lucide-react';
import { useCaseGroups } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons = [CoffeeIcon, ChurchIcon, MapPinIcon];
export function UseCases() {
  return <section aria-labelledby="usecases-title" className="bg-paper" data-id="element-268" data-mp="35eufeoqifjjy">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-269" data-mp="31f3nghp8yxdu">
        <SectionHeading id="usecases-title" title="Made for Real-Life Gospel Sharing" intro="Picture a few cards in your bag, your car, or on the welcome table — ready the moment an opportunity shows up." data-id="element-270" data-mp="2whjzgq2qz68p" />
        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-0 md:divide-x md:divide-cream-line" data-id="element-271" data-mp="2mk5x1udnshze">
          {useCaseGroups.map((g, i) => {
          const Icon = icons[i];
          return <div key={g.title} className="flex flex-col md:px-8 md:first:pl-0 md:last:pr-0" data-id="element-272" data-mp="kon71muj3xn1" data-mpi={i}>
                <Icon className="h-7 w-7 text-coral" strokeWidth={1.75} aria-hidden="true" data-id="element-273" data-mp="gnjqey4npxkr" />
                <h3 className="mt-4 font-display text-[28px] leading-tight text-navy" data-id="element-274" data-mp="2rwadiyqdrikq">{g.title}</h3>
                <p className="mt-3 min-h-[3.5rem] italic leading-relaxed text-ink-soft" data-id="element-275" data-mp="2wr7jfwsd5bte">{g.scene}</p>
                <ul className="mt-6 space-y-3 border-t border-cream-line pt-6" data-id="element-276" data-mp="2ivlzw54wfk8d">
                  {g.items.map(item => <li key={item} className="flex items-center gap-3 font-semibold text-navy" data-id="element-277" data-mp="3akyuxapnn5rr">
                      <CheckIcon className="h-4 w-4 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-278" data-mp="3fjihndc2oll6" />
                      {item}
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}